import {useEffect, useState} from "react";
import styled from 'styled-components';

import {useParams} from "react-router-dom";
import useFeedback from "../../../utils/use_feedback";
import {useCommunitySettings, useSaveSettings} from "../../../api/communities";
import {useSaveClicked} from "../../../store";
import FormContainer from "../../../components/form_container";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import {
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    Stack,
    useToast
} from "@chakra-ui/react";

const SwitchHeading = styled.div``;

const VotingCommunitySettings = styled(({className}) => {
    const {community} = useParams();
    const {error, feedbackCh} = useFeedback();
    const [settings, setSettings] = useState({
            displayName: '',
            appSafe: '',
            description: '',
            topics: [],
            nsfw: false,
        }
    );
    useCommunitySettings(feedbackCh, community, setSettings);
    const set = (name) => (value) => setSettings((settings) => ({...settings, [name]: value}));

    const saveSettings = useSaveSettings(feedbackCh);
    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    const toast = useToast();
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    setSaving(true);
                    toast({
                        title: `Saving...`,
                        status: 'info',
                        isClosable: true,
                    });
                    await saveSettings(community, settings);
                    toast.closeAll();
                    toast({
                        title: `Saved settings.`,
                        status: 'success',
                        isClosable: true,
                    });
                    setSaving(false);
                }
            }
        })().then(() => {
        }, () => {
        });
    }, [saveClicked]);

    return (
        <>
            <FixedTopBar back title="Voting Restrictions" border={false} save/>
            <WhiteMain className={className}>
                <FormContainer>
                    <p>Note that voting restrictions will eventually be discontinued.</p>
                    <Stack spacing={'1'} mb={8}>
                        <SwitchHeading>Min. Score to Vote on Posts</SwitchHeading>
                        <NumberInput value={settings.minScorePosts} min={0} max={100}
                                     onChange={(e) => set('minScorePosts')(e)}>
                            <NumberInputField/>
                            <NumberInputStepper>
                                <NumberIncrementStepper/>
                                <NumberDecrementStepper/>
                            </NumberInputStepper>
                        </NumberInput>
                    </Stack>

                    <Stack spacing={'1'} mb={8}>
                        <SwitchHeading>Min. Score to Vote on Comments</SwitchHeading>
                        <NumberInput value={settings.minScoreComments} min={0} max={100}
                                     onChange={(e) => set('minScoreComments')(e)}>
                            <NumberInputField/>
                            <NumberInputStepper>
                                <NumberIncrementStepper/>
                                <NumberDecrementStepper/>
                            </NumberInputStepper>
                        </NumberInput>
                    </Stack>

                    <Stack spacing={'1'} mb={8}>
                        <SwitchHeading>Min. Score to Downvote Posts</SwitchHeading>
                        <NumberInput value={settings.minScoreDownPosts} min={0} max={100}
                                     onChange={(e) => set('minScoreDownPosts')(e)}>
                            <NumberInputField/>
                            <NumberInputStepper>
                                <NumberIncrementStepper/>
                                <NumberDecrementStepper/>
                            </NumberInputStepper>
                        </NumberInput>
                    </Stack>

                    <Stack spacing={'1'}>
                        <SwitchHeading>Min. Score to Downvote Comments</SwitchHeading>
                        <NumberInput value={settings.minScoreDownComments} min={0} max={100}
                                     onChange={(e) => set('minScoreDownComments')(e)}>
                            <NumberInputField/>
                            <NumberInputStepper>
                                <NumberIncrementStepper/>
                                <NumberDecrementStepper/>
                            </NumberInputStepper>
                        </NumberInput>
                    </Stack>
                </FormContainer>
            </WhiteMain>
        </>
    );
})`
  p {
    font-size: 15px;
    padding-bottom: 12px;
  }

  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }
  ${SwitchHeading} {
    font-weight: 600;
    font-size: 15px;
    padding: 6px 0;
  }
`;

export default VotingCommunitySettings;
